import { render, staticRenderFns } from "./OrganizerCard.vue?vue&type=template&id=e69e0df2&scoped=true&"
import script from "./OrganizerCard.vue?vue&type=script&lang=js&"
export * from "./OrganizerCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e69e0df2",
  null
  
)

export default component.exports